import _ from "lodash";
import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Link, useParams, useRouteMatch, Route, Switch, Redirect } from "react-router-dom";
import PageTitle, { BreadCrumbs } from "components/standart/PageTitle";
import { Nav, NavLink, NavItem } from "reactstrap";
import IntlMessages from "util/intlMessages";
import { Error400 } from "views/pages";
import { adminAPI } from "redux/api";

import Form from "./Form";
import Stats from "./Stats";
import ChannelsMessages from "./Messages";
import ChannelSettings from "./Settings";
import ChannelsTariffs from "./Tariffs";
import { apiUrls, formLink } from "./init";

const { api } = adminAPI.actions;

const ChannelInfo = (props) => {
  const { url, path } = useRouteMatch();
  const params = useParams();
  const { breadCrumbs } = props;
  const [currentTab, setCurrentTab] = useState(0);
  const [channel, setChannel] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const onSuccess = (body) => {
      setChannel(body);
    };
    const onFailure = ({ status }) => {
      setNotFound(404 === status);
    };

    props.getChannel({ params }, { onSuccess, onFailure });
  }, []);

  if (channel) {
    breadCrumbs.push({
      title: [channel.name].filter(_.size).join(" / "),
      url,
      actions: [
        <Link to={formLink(channel)}>
          <i className="fa fa-edit" />
        </Link>,
      ],
    });
  }

  const NavTabs = [
    /*
    {
      path: "",
      title: <IntlMessages id="Channels.Stats" />,
      component: <Stats {...channel} />,
    },
    */
    {
      path: "/messages",
      title: <IntlMessages id="Channels.Messages" />,
      component: <ChannelsMessages />,
    },
    /*
    {
      path: "/tafiffs",
      title: <IntlMessages id="Tariffs" />,
      component: <ChannelsTariffs />,
    },
    */
    {
      path: "/form",
      title: <IntlMessages id="Channels.Form" />,
      component: <Form {...{ channel, setChannel }} />,
    },
    /*
    {
      path: "/settings",
      title: <IntlMessages id="Channels.Settings" />,
      component: <ChannelSettings {...{ channel, setChannel }} />,
    },
    */
  ];
  return (
    <>
      {notFound && <Error400 />}
      {channel ? (
        <Fragment>
          <PageTitle {...breadCrumbs} />

          <>
            <div className="mb-1">
              <Nav tabs>
                {NavTabs.map((navTab, index) => {
                  const link = url + _.toString(navTab.path);
                  return (
                    <Fragment key={index}>
                      <NavItem>
                        <span className={`nav-link ${currentTab === index ? "active" : ""}`}>
                          <Link to={link}>{navTab.title || <IntlMessages id={navTab.id} />}</Link>
                        </span>
                      </NavItem>
                    </Fragment>
                  );
                })}
              </Nav>
            </div>

            <Switch>
              {NavTabs.map((navTab, index) => {
                const link = path + _.toString(navTab.path);
                return (
                  <Route
                    key={index}
                    exact
                    path={link}
                    render={() => {
                      setCurrentTab(index);
                      return <Fragment key={index}>{navTab.component}</Fragment>;
                    }}
                  />
                );
              })}
              <Route
                exact
                path={path}
                render={() => <Redirect to={`${url}${NavTabs[0].path}`} />}
              />
            </Switch>
          </>
        </Fragment>
      ) : null}
    </>
  );
};

export default connect(null, {
  getChannel: api.get(apiUrls.info),
})(ChannelInfo);
